import * as ACTION from '../constants';
import * as saga from './saga';
import {takeLatest} from 'redux-saga/effects';

export default function* () {
	yield takeLatest(ACTION.CREATE_PROPERTY.REQUEST, saga.createProperty);
	yield takeLatest(ACTION.CREATE_PROPERTY.SUCCESS, saga.createPropertySuccess);
}
